import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import { isIdType } from 'types/utils';
export function arrayToSortedString(value) {
  return value.map(function (item) {
    return isIdType(item) ? item : item.id;
  }).sort().join(',');
}

/**
 * Generic function which checks whether a value is the same as another value.
 * Supports all primitive values and arrays consisting of strings, numbers, or objects with ids.
 */

export default function areValuesEqual(valueOne, valueTwo) {
  var isArray = Array.isArray(valueOne) && Array.isArray(valueTwo);
  if (isArray) {
    return arrayToSortedString(valueOne) === arrayToSortedString(valueTwo);
  } else {
    return valueOne === valueTwo;
  }
}